<template>
  <div v-if="campaign" class="landing-page">
    <div class="landing-header">
      <img class="landing-header-bg-image" :src="coverImage" crossorigin="*" />
      <div class="export-btn-container" data-html2canvas-ignore="true">
        <button class="btn btn-primary" @click="exportPdfPage">Export PDF</button>
      </div>
      <div class="landing-header-content">
        <div class="landing-header-report" v-if="campaign.type == 'property' || campaign.type == 'property extend'">Property Campaign Report</div>
        <div class="landing-header-report" v-else>Campaign Report</div>

        <div class="landing-header-title" v-if="campaign.type == 'property' || campaign.type == 'property extend'">{{ campaign.title }}</div>
        <div class="landing-header-title" v-else>{{ productType }} Campaign</div>
      </div>
    </div>
    <div class="landing-table">
      <div class="landing-table-cell">
        <div class="landing-cell-head">Campaign Start Date</div>
        <div class="landing-cell-value">{{campaign.startDate}}</div>
      </div>
      <div class="landing-table-cell">
        <div class="landing-cell-head">Campaign Duration</div>
        <div class="landing-cell-value">{{ campaign.package.duration }} days</div>
      </div>
      <div class="landing-table-cell">
        <div class="landing-cell-head">Package</div>
        <div class="landing-cell-value">{{campaign.package ? campaign.package.title : ''}}</div>
      </div>
      <div class="landing-table-cell" v-if="campaign.type == 'office'">
        <div class="landing-cell-head">Office</div>
        <div class="landing-cell-value">{{campaign.officeName}}</div>
      </div>
      <div class="landing-table-cell" v-else>
        <div class="landing-cell-head">Agent</div>
        <div class="landing-cell-value">{{campaign.agentName}}</div>
      </div>
      <div class="landing-table-cell">
        <div class="landing-cell-head">Report Date</div>
        <div class="landing-cell-value">{{reportDate}}</div>
      </div>
    </div>
    <div class="landing-content-container">
      <div class="flex-centered awareness-header">
        <template v-if="campaign.type == 'property' || campaign.type == 'property extend'">Find buyers beyond the real estate sites</template>
        <template v-else-if="campaign.type == 'agent extend'">Your Free Agent Extend Campaign is now complete</template>
        <template v-else-if="campaign.type == 'office'">Reaching Your Audience, Your Way</template>
        <template v-else>Find your Next Listing</template>
      </div>
      <div class="flex-centered awareness">
        Awareness
      </div>
      <div class="flex-centered impressions-logo">
        &nbsp;
      </div>
      <div class="flex-centered impressions-title">
        Ad Impressions
      </div>
      <div class="flex-centered impressions-value">
        {{campaign.stats ? Number(campaign.stats.impressions).toLocaleString() : 0}}
      </div>
      <div class="flex-centered impressions-tooltip" v-if="campaign.type=='property' || campaign.type=='property extend'">
        The number of times the ad was shown to potential {{ campaign.type=='property' || campaign.type=='property extend' ? 'buyers' : 'vendors' }}
      </div>
      <div class="flex-centered impressions-tooltip" v-else>
        The number of times your ad was shown to your audience
      </div>
      <div class="flex-centered enquiry-heading page-break" v-if="campaign.type=='office'">
        Interest & Enquiry
      </div>
      <div class="flex-centered enquiry-heading page-break" v-else>
        Direct Interest & Enquiry
      </div>
      <property-campaign-stats :campaign="campaign" v-if="campaign.type=='property' || campaign.type=='property extend'"/>
      <agent-extend-campaign-stats :campaign="campaign" v-else-if="campaign.type == 'agent extend'"/>
      <agency-campaign-stats :campaign="campaign" v-else-if="campaign.type == 'agent'"/>
      <office-campaign-stats :campaign="campaign" v-else-if="campaign.type == 'office'"/>
      <div class="clientLogoWrapper">
        <img class="clientLogo" :src="clientLogo" crossorigin="*" />
      </div>
    </div>
  </div>
</template>

<script>
  import CampaignService from '../../../services/campaigns';
  import PropertyCampaignStats from './PropertyCampaignStats';
  import AgencyCampaignStats from './AgencyCampaignStats';
  import AgentExtendCampaignStats from './AgentExtendCampaignStats';
  import OfficeCampaignStats from './OfficeCampaignStats';
  import moment from 'moment';
  import formatCapitalize  from '../../../filters/formatCapitalize';

  export default {
    components: {
      PropertyCampaignStats,
      AgencyCampaignStats,
      AgentExtendCampaignStats,
      OfficeCampaignStats
    },
    data() {
      return {
        campaign: null,
        coverImage: '/landing-page-bg.jpg',
        productType: null
      }
    },
    methods: {
      exportPdfPage() {
        var element = document.body;
        var opt = {
          margin:       0,
          filename:     this.campaign.title,
          image:        { type: 'jpeg', quality: 1 },
          html2canvas:  { scale: 1, useCORS: true, logging: true, allowTaint : true, proxy: []},
          jsPDF:        { unit: 'in', format: 'a4', orientation: 'portrait' }
        };

        // New Promise-based usage:
        html2pdf().set(opt).from(element).save();
      }
    },
    mounted() {
      if(this.$route.params.campaignId) {
        CampaignService.getCampaignPublic(this.$route.params.campaignId, this.$route.params.token).then(result => {
          this.campaign = result;
          if (this.campaign.endDate) {
            var endDate = moment(this.campaign.endDate);
            var now = moment();
            var diffDays = now.diff(endDate, 'days');
            if (diffDays > 90) {
              this.$router.push('/404')
            }
          }
          if (this.campaign && this.campaign.productResponse && this.campaign.productResponse.Data) {
            this.productType = formatCapitalize.splitCamelCaseAndCapitalize(this.campaign.productResponse.Data.ProductType);
          }
          if(this.campaign.client && this.campaign.client.clientDisplayConfig && this.campaign.client.clientDisplayConfig.landingPageCover) {
            this.coverImage = `${process.env.VUE_APP_CDN_URL}${this.campaign.client.clientDisplayConfig.landingPageCover.location}?x-request=` + Math.floor(Math.random() * 1000000)
          }
        });
      }
    },
    computed: {
      clientLogo: function() {
        if (this.campaign && this.campaign.logo) {
          return `${process.env.VUE_APP_CDN_URL}${this.campaign.logo}?x-request=` + Math.floor(Math.random() * 1000000);
        } else {
          return null;
        }
      },
      reportDate: function() {
        return moment().format('DD.MM.YYYY');
      },
    }
  }
</script>

<style lang="css" scoped>
  .landing-header {
    background: var(--bkgImage);
  }
</style>
